import { isDev } from "@utils/env";
import { useTranslation } from "react-i18next";

interface BrandingProps {
  className?: string;
  showDevBadge?: boolean;
}

function Branding({ className = "", showDevBadge = true }: BrandingProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <img src="/logo.svg" alt={t("branding_logo_alt")} className="h-8 w-8" />
      <span className="text-xl font-bold tracking-tight text-gray-800">
        Copicake
      </span>
      {showDevBadge && isDev && (
        <span className="rounded-full bg-red-100 px-2 py-1 text-xs font-semibold text-red-600">
          {t("branding_dev_badge")}
        </span>
      )}
    </div>
  );
}

export default Branding;
